export const settings = {
  namespaced: true,

  state: {
    cadUsdRate: 0.73
  },

  getters: {
    cadUsdRate: state => state.cadUsdRate
  },

  mutations: {
    SET_RATE(state, rate) {
      state.cadUsdRate = Number(rate)
    }
  }
}
